module.exports = __webpack_public_path__ + "img/donante-ayuntamiento-tijuana.fe10ecd6.png";